import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

interface PortalDsEmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export function PortalDsEmptyState({
  title,
  description,
  icon,
  action,
  className,
}: PortalDsEmptyStateProps) {
  return (
    <div className={cn(portalDs.emptyState, className)}>
      {icon ? <div className={portalDs.emptyIcon}>{icon}</div> : null}
      <p className={portalDs.emptyTitle}>{title}</p>
      {description ? <p className={portalDs.emptyDesc}>{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
